export default "__VITE_ASSET__DDZ3Z3ye__"